// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import userEvaluation css modules
import userEvaluationStyles from '../userEvaluationModuleStyles.css';

function UserEvaluationListItem({ userEvaluation }) {
  return (
    <li>
      <Link to={`/user-evaluations/${userEvaluation._id}`}> {userEvaluation.name}</Link>
    </li>
  )
}

UserEvaluationListItem.propTypes = {
  userEvaluation: PropTypes.object.isRequired
}

export default UserEvaluationListItem;



// WEBPACK FOOTER //
// modules/userEvaluation/components/UserEvaluationListItem.js.jsx